// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./page-rtl.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --modal-close-display: none;
  --modal-backdrop-pointer-events: none;
}

.hidden {
  display: none !important;
}

#hotmart-cookie_alert-component {
  padding: var(--spacer-5);
}

#hotmart-cookie_alert-component .cookie-policy-background {
  background-color: var(--white);
}

#hotmart-cookie_alert-component .cookie-policy-close {
  background: transparent;
  border: 0;
  cursor: pointer;
}

#hotmart-cookie_alert-component a {
  cursor: pointer
}

#hotmart-cookie_alert-component .cookie-policy-footer button:not(:first-of-type) {
  margin-left: var(--spacer-4)
}

#hotmart-cookie-modal-configuration hot-list-group>hot-list-group-item {
  border-radius: var(--border-radius) !important;
  padding-right: 0px;
}

#hotmart-cookie-modal-configuration hot-list-group>hot-list-group-item:not(:first-of-type) {
  margin-top: var(--spacer-4);
}

#hotmart-cookie-modal-configuration hot-modal-body p {
  color: var(--gray-500);
  line-height: var(--line-height-lg)
}

#hotmart-cookie-modal-configuration hot-list-group-item div[slot="collapsed"] {
  color: var(--gray-700);
  line-height: var(--line-height-lg);
  margin-top: var(--spacer-2);
  margin-right: var(--spacer-4)
}

#hotmart-cookie-modal-configuration .cookie-policy-confirm-btn {
  border-radius: calc(var(--border-radius) / 2)
}

@media all and (max-width: 768px) {
  #hotmart-cookie_alert-component {
    padding: var(--spacer-3)
  }

  #hotmart-cookie_alert-component .cookie-policy-background {
    background-color: var(--gray-100);
  }

  #hotmart-cookie_alert-component .cookie-policy-footer {
    flex-direction: column;
  } 

  #hotmart-cookie_alert-component .cookie-policy-footer button {
    width: 100%;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button:not(:first-of-type) {
    margin-left: 0;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button:not(.hidden) ~ button {
    margin-top: var(--spacer-3);
  }
}
`, "",{"version":3,"sources":["webpack://./src/cookie-banner/styles/page.css"],"names":[],"mappings":"AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@import \"page-rtl.css\";\n\n:host {\n  --modal-close-display: none;\n  --modal-backdrop-pointer-events: none;\n}\n\n.hidden {\n  display: none !important;\n}\n\n#hotmart-cookie_alert-component {\n  padding: var(--spacer-5);\n}\n\n#hotmart-cookie_alert-component .cookie-policy-background {\n  background-color: var(--white);\n}\n\n#hotmart-cookie_alert-component .cookie-policy-close {\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n}\n\n#hotmart-cookie_alert-component a {\n  cursor: pointer\n}\n\n#hotmart-cookie_alert-component .cookie-policy-footer button:not(:first-of-type) {\n  margin-left: var(--spacer-4)\n}\n\n#hotmart-cookie-modal-configuration hot-list-group>hot-list-group-item {\n  border-radius: var(--border-radius) !important;\n  padding-right: 0px;\n}\n\n#hotmart-cookie-modal-configuration hot-list-group>hot-list-group-item:not(:first-of-type) {\n  margin-top: var(--spacer-4);\n}\n\n#hotmart-cookie-modal-configuration hot-modal-body p {\n  color: var(--gray-500);\n  line-height: var(--line-height-lg)\n}\n\n#hotmart-cookie-modal-configuration hot-list-group-item div[slot=\"collapsed\"] {\n  color: var(--gray-700);\n  line-height: var(--line-height-lg);\n  margin-top: var(--spacer-2);\n  margin-right: var(--spacer-4)\n}\n\n#hotmart-cookie-modal-configuration .cookie-policy-confirm-btn {\n  border-radius: calc(var(--border-radius) / 2)\n}\n\n@media all and (max-width: 768px) {\n  #hotmart-cookie_alert-component {\n    padding: var(--spacer-3)\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-background {\n    background-color: var(--gray-100);\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer {\n    flex-direction: column;\n  } \n\n  #hotmart-cookie_alert-component .cookie-policy-footer button {\n    width: 100%;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button:not(:first-of-type) {\n    margin-left: 0;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button:not(.hidden) ~ button {\n    margin-top: var(--spacer-3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
